import React from 'react'
import {Card} from "primereact/card";
import DHDefaultDrawer from "../../general/DHDefaultDrawer";
import DHButtonDefault from "../../general/DHButtonDefault";

export default function VeranstalterTipps({onClose}) {

    return <DHDefaultDrawer title="Hilfe" show={true} onClose={() => onClose()} children={<>
        <div style={{padding: 20}}>
            <div style={{fontWeight: "bold", marginBottom: 5}}>Scorer richtig einrichten (wichtig!)</div>
            <div style={{marginBottom: 20}}><a href="https://support.darthelfer.de/viewtopic.php?t=121" target="_blank" rel="noopener noreferrer">https://support.darthelfer.de/viewtopic.php?t=121</a></div>
            <div style={{fontWeight: "bold", marginBottom: 5}}>Youtube-Kanal (Hilfevideos)</div>
            <div style={{marginBottom: 20}}><a href="https://www.youtube.com/@darthelfer" target="_blank" rel="noopener noreferrer">https://www.youtube.com/@darthelfer</a></div>
            <div style={{fontWeight: "bold", marginBottom: 5}}>Hilfe zum Anlegen von Veranstaltern / Boards</div>
            <div style={{marginBottom: 20}}><a href="https://support.darthelfer.de/viewtopic.php?t=100" target="_blank" rel="noopener noreferrer">https://support.darthelfer.de/viewtopic.php?t=100</a>
            </div>
            <div style={{fontWeight: "bold", marginBottom: 5}}>Vergleich Versionen - kostenlos vs. Bezahlversion</div>
            <div style={{marginBottom: 20}}><a href="https://support.darthelfer.de/viewtopic.php?t=101" target="_blank" rel="noopener noreferrer">https://support.darthelfer.de/viewtopic.php?t=101</a>
            </div>
            <div style={{fontWeight: "bold", marginBottom: 5}}>Allgemeine Hilfen im Supportforum</div>
            <div style={{marginBottom: 20}}><a href="https://support.darthelfer.de" target="_blank" rel="noopener noreferrer">https://support.darthelfer.de</a></div>
            <div style={{fontWeight: "bold", marginBottom: 5}}>Neuigkeiten/Infos in sozialen Netzwerken</div>
            <div style={{marginBottom: 20}}><a href="https://www.facebook.com/darthelfer" target="_blank" rel="noopener noreferrer">https://www.facebook.com/darthelfer</a></div>
        </div>
    </>}/>
}
